import { useNavigate } from "react-router-dom";
import { useTranslation } from "../../i18n/LanguageContext";
import { Button } from "../ui/button"

interface SubHeaderProps {
  moduleName: string
  description?: string
  className?: string
  OptionalAction?: boolean
}

export default function SubHeader({
  moduleName,
  OptionalAction = false,
  className = ""
}: SubHeaderProps) {
  const t = useTranslation();
  const navigate = useNavigate();
  return (
    <div className={`w-full ${className}`}>
      <div className="px-2 sm:px-4 pt-2">
        <div className="flex items-center justify-between">
          <div className="min-w-0 flex-1">
            <h2 className="text-xl sm:text-xl font-bold text-foreground tracking-tight truncate">
              {moduleName}
            </h2>
            {/* {description && (
              <p className="text-sm text-muted-foreground mt-1 truncate">
                {description}
              </p>
            )} */}
          </div>
          
          {/* Optional: Add module-specific actions here */}
          {OptionalAction && (
          <div className="flex items-center gap-2 shrink-0">
            {/* This space can be used for module-specific buttons/actions */}
              <div className="flex justify-end shrink-0">
                  <Button
                  variant={'ghost'}
                  size="sm"
                  className="text-sm"
                    onClick={() => navigate('/analytics')}
                  >
                    <img src="/icons/analyticswebinar.svg" alt="analytics" className="w-4 h-4 sm:w-3.5 sm:h-3.5" />
                    <span className="hidden sm:block">{t("analytics.title")}</span>
                  </Button>
                    <Button
                    variant="ghost"
                    className="text-sm"
                    onClick={() => navigate('/analytics/recordings')}
                  > 
                    <img src="/icons/recordingIcon.svg" alt="analytics" className="w-7 h-7 sm:w-5 sm:h-5" />

                  
                    <span className="hidden sm:block">{t("analytics.meetingRecordings")}</span>

                  </Button>
                </div>
          </div>
          )}
        </div>
      </div>
    </div>
  )
}
